<div class="users-page">
    <div class="settings-header">
        <div class="settings-header-row">
            <div class="left">
                <input type="text" class="search-filter" placeholder="Search by name, email, or company"
                placeholder="{{ 'USER.SEARCH_PLACEHOLDER' | translate }}"
                    [(ngModel)]="searchQuery" (ngModelChange)="onSearch()">
            </div>
            <div class="right">
                <button class="primary-button" (click)="onNewUserClick()">
                    {{ 'USER.NEW_USER' | translate }}
                </button>
            </div>
        </div>
    </div>
    <div class="parent-container" #userListContainer>
        <div class="settings-list" >
            <ng-container *ngFor="let user of filteredUsers; let i = index">
                <div class="row-container" [ngClass]="{ 'detailled': expandedRowIndex === i }" #rowElement>
                    <div class="row pe-0">
                        <div class="table-column name">
                            <div class="text-muted">{{ 'USER.NAME' | translate }}</div>
                            <div>{{ user?.firstName }} {{ user?.lastName }}</div>
                        </div>
                        <div class="table-column mail">
                            <div class="text-muted">{{ 'USER.MAIL' | translate }}</div>
                            <div class="default-text" title="{{ user.email }}">{{ user.email.length > 20 ? (user.email
                                |
                                slice:0:20) + '...' : user.email }}</div>
                        </div>
                        <div class="table-column company">
                            <div class="text-muted">{{ 'USER.COMPANY' | translate }}</div>
                            <div>{{ user.companyName }}</div>
                        </div>
                        <div class="table-column organization">
                            <div class="text-muted">{{ 'USER.MAIN_ORGANISATION' | translate }}</div>
                            <div>{{ user.organizationIds }}</div>
                        </div>
                        <div class="table-column language">
                            <div class="text-muted">{{ 'USER.LANGUAGE' | translate }}</div>
                            <div>{{ user.langueIsoCode | uppercase }}</div>
                        </div>
                        <div class="table-column status">
                            <div class="text-muted">{{ 'USER.STATUS' | translate }}</div>
                            <span class="status-icon" [ngClass]="{ 'active': user.enabled }">
                                <svg-icon [src]="user.enabled ? './icon/active.svg' : './icon/inactive.svg'"></svg-icon>
                                <span class="status-text">{{ (user.enabled ? 'SETTINGS.ACTIVE' : 'SETTINGS.INACTIVE') | translate }}</span>
                              </span>
                        </div>
                        <div class="table-column actions">
                            <div class="actions-wrapper d-flex align-items-center">
                                <button class="secondary-button" (click)="onModifyUser(user); $event.stopPropagation()">
                                    <svg-icon src="./icon/edit-pencil.svg"></svg-icon>
                                    {{ 'USER.MODIFY' | translate }}
                                </button>

                            </div>
                            <button class="collapse-toggle ms-auto"
                            (click)="toggleRowDetails(i, user.userId); $event.stopPropagation()">
                            <img [src]="expandedRowIndex === i ? './icon/arraw-up.svg' : './icon/arraw-down.svg'"
                            class="arrow-icon" />
                        </button>
                        </div>
                    </div>
                    <div class="collapse-content details-list" *ngIf="expandedRowIndex === i">
                        <div class="detail-line">
                            <div class="text-muted">{{ 'USER.NAME' | translate }}</div>
                            <div>{{ user.firstName }} {{ user.lastName }}</div>
                        </div>
                        <div class="detail-line">
                            <div class="text-muted">{{ 'USER.MAIL' | translate }}</div>
                            <div>{{ user.email }}</div>
                        </div>
                        <div class="detail-line">
                            <div class="text-muted">{{ 'USER.AREAS' | translate }}</div>
                            <div>{{ getRegionNames(user) }}</div>
                        </div>
                        <div class="detail-line">
                            <div class="text-muted">{{ 'USER.SITES' | translate }}</div>
                            <div>{{ getSiteNames(user) }}</div>
                        </div>
                        <div class="detail-line">
                            <div class="text-muted">{{ 'USER.COMPANY' | translate }}</div>
                            <div>{{ user.companyName }}</div>
                        </div>
                        <div class="detail-line">
                            <div class="text-muted">{{ 'USER.MAIN_ORGANISATION' | translate }}</div>
                            <div>{{ user.organizationIds }}</div>
                        </div>
                        <!--<div class="detail-line">
                            <strong>SECONDARY ORGANIZATION</strong>
                            <span>{{ user.secondaryOrganizations.join(', ') || 'None' }}</span>
                        </div>-->
                        <div class="detail-line">
                            <div class="text-muted">{{ 'USER.ROLE' | translate }}</div>
                            <div>{{ user?.groups?.exploreGroups }}</div>
                        </div>
                    </div>
                </div>
            </ng-container>
        </div>
    </div>
</div>